const defined = obj => obj || {};

export const financialPlanWarning = state => state.FinancialPlanWarning;

export const warningMessage = (state, props) =>
  defined(financialPlanWarning(state)[props.clientId]).warningMessage;

export const warningType = (state, props) =>
  defined(financialPlanWarning(state)[props.clientId]).warningType;

export const hasWarningMessage = (state, props) => !!warningMessage(state, props);

export const key = (state, props) =>
  defined(financialPlanWarning(state)[props.clientId]).key || '_';

export const hidden = (state, props) =>
  // eslint-disable-next-line
  defined(financialPlanWarning(state)[props.clientId]).hasOwnProperty(key(state, props));
